import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import type { PlatformBlockComponent } from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";
import { TextField } from "@/shared/components/Form/TextField";
import { AutocompleteField } from "@/shared/components/Form/AutocompleteField";
import { Switch } from "@/shared/components/Form/Switch";
import { ItemsPerRowField } from "../../ItemsPerRowField";

const viewValues = ["CAROUSEL", "GRID"] as const;

const variantValues = ["TITLE_INSIDE", "TITLE_OUTSIDE"] as const;

export const Posts: PlatformBlockComponent = ({
  name,
  platformId,
  values,
  queries,
}) => {
  const { t } = useTranslation();

  const viewOptions = viewValues.map((value) => ({
    value,
    label: t(`platformBlocks.view.${value}`),
  }));

  const variantOptions = variantValues.map((value) => ({
    value,
    label: t(`platformBlocks.postsVariant.${value}`),
  }));

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="POSTS" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.title`}
            label={t("platformBlocks.fields.title")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <AutocompleteField
            name={`${name}.view`}
            label={t("platformBlocks.fields.view")}
            fullWidth
            options={viewOptions}
          />
        </Grid>

        {(values?.props as { view?: string })?.view === "CAROUSEL" && (
          <Grid size={12}>
            <AutocompleteField
              name={`${name}.variant`}
              label={t("platformBlocks.fields.variant")}
              fullWidth
              options={variantOptions}
            />
          </Grid>
        )}
        <Grid size={12}>
          <AutocompleteField
            multiple
            name={`${name}.tagIds`}
            label={t("platformBlocks.fields.tags")}
            fullWidth
            query={queries?.autocompleteTags}
            queryVariables={
              platformId
                ? {
                    filter: { platformId },
                  }
                : undefined
            }
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ItemsPerRowField
            name={`${name}.itemsPerRow`}
            label={t("platformBlocks.fields.itemsInRow")}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.limit`}
            label={t("platformBlocks.fields.totalItems")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={12}>
          <TextField
            name={`${name}.moreText`}
            label={t("platformBlocks.fields.moreText")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={12}>
          <Switch
            name={`${name}.useCurrentTag`}
            label={t("platformBlocks.fields.useCurrentTag")}
            helperText={t("platformBlocks.fields.useCurrentTagHelper")}
          />
        </Grid>
        <Grid>
          <Switch
            name={`${name}.loadMore`}
            label={t("platformBlocks.fields.loadMore")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
